import styled from "@emotion/styled"
import Drawer from "@material-ui/core/Drawer"
import List from "@material-ui/core/List"
import TapBarItem from "./TapBarItem"

export const TAP_BAR_HEIGHT = "5.6rem"
export const TAP_BAR_MEDIA_QUERY_UP = "sm"
export const TAP_BAR_MEDIA_QUERY_DOWN = "xs"

export const StyledTapBar = styled(Drawer)``

export const StyledList = styled(List)`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  height: ${TAP_BAR_HEIGHT};
  padding: 0;
` as typeof List

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledTapBarItem = styled(TapBarItem as any)`
  flex-grow: 1;
  display: flex;
  align-items: stretch;
`
